export default "__VITE_ASSET__4ddc0923__"